import { useState, useEffect, useCallback } from "react";
import { PageHeader } from "../../page-header";
import { TbHistory, TbUser, TbPackage, TbCheck, TbAlertTriangle, TbTrash } from "react-icons/tb";
import { apiV1 } from "../../../lib/axios";
import "../PagamentoLote.css";
import "./PagamentoLoteHistorico.css";

const ACTION_ICONS = {
  "Criou lote":         <TbPackage size={14} />,
  "Validou contas":     <TbAlertTriangle size={14} />,
  "Liberou pagamento":  <TbCheck size={14} />,
  "Aprovou lote":       <TbCheck size={14} />,
  "Rejeitou lote":      <TbAlertTriangle size={14} />,
  "Excluiu lote":       <TbTrash size={14} />,
  "Adicionou conta":    <TbUser size={14} />,
  "Excluiu conta":      <TbUser size={14} />,
  "Enviou para aprovação": <TbCheck size={14} />,
};

const ACTION_COLOR = {
  "Criou lote":        "blue",
  "Validou contas":    "orange",
  "Liberou pagamento": "green",
  "Aprovou lote":      "green",
  "Rejeitou lote":     "red",
  "Adicionou conta":   "blue",
};

const ACTION_LABELS = {
  CRIOU_LOTE:           "Criou lote",
  APROVOU_LOTE:         "Aprovou lote",
  REJEITOU_LOTE:        "Rejeitou lote",
  EXCLUIU_LOTE:         "Excluiu lote",
  ADICIONOU_CONTA:      "Adicionou conta",
  VALIDOU_CONTAS:       "Validou contas",
  LIBEROU_PAGAMENTO:    "Liberou pagamento",
  BATCH_CREATED:        "Criou lote",
  BATCH_APPROVED:       "Aprovou lote",
  BATCH_REJECTED:       "Rejeitou lote",
  BATCH_RELEASED:       "Liberou pagamento",
  BATCH_DELETED:        "Excluiu lote",
  PAYMENT_RELEASED:     "Liberou pagamento",
  ACCOUNTS_VALIDATED:   "Validou contas",
  ACCOUNT_ADDED:        "Adicionou conta",
  PAYMENT_ADDED:        "Adicionou conta",
  ENVIOU_PARA_APROVACAO: "Enviou para aprovação",
  "batch-created":      "Criou lote",
  "batch-approved":     "Aprovou lote",
  "batch-rejected":     "Rejeitou lote",
  "batch-released":     "Liberou pagamento",
  "batch-deleted":      "Excluiu lote",
  "accounts-validated": "Validou contas",
  "account-added":      "Adicionou conta",
  "Criou lote":         "Criou lote",
  "Validou contas":     "Validou contas",
  "Liberou pagamento":  "Liberou pagamento",
  "Aprovou lote":       "Aprovou lote",
  "Rejeitou lote":      "Rejeitou lote",
  "Excluiu lote":       "Excluiu lote",
  "Adicionou conta":    "Adicionou conta",
};

const ACTION_COLOR_MAP = {
  ...ACTION_COLOR,
  "Excluiu lote": "red",
};

function formatDateTime(value) {
  if (!value) return "—";
  if (/^\d{2}\/\d{2}\/\d{4}/.test(value)) return value;
  const d = new Date(value);
  if (isNaN(d)) return value;
  return d.toLocaleString("pt-BR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export default function PagamentoLoteHistorico() {
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filterUser, setFilterUser] = useState("");
  const [filterAction, setFilterAction] = useState("");

  const fetchHistorico = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (search)       params.append("search",  search);
      if (filterUser)   params.append("usuario", filterUser);
      if (filterAction) params.append("acao",    filterAction);
      const response = await apiV1.get(`/batch-payments/history?${params.toString()}`);
      setHistorico(response.data.data || []);
    } catch (err) {
      console.error("Erro ao carregar histórico:", err);
    } finally {
      setLoading(false);
    }
  }, [search, filterUser, filterAction]);

  useEffect(() => {
    fetchHistorico();
  }, [fetchHistorico]);

  return (
    <div className="paylote-page">
      <div className="paylote-inner col-md-10 m-auto mt-4">
        <div className="mb-3">
          <PageHeader
            title="Histórico"
            pages={[
              { name: "Pagamento em Lote", href: "/pagamento-lote/dashboard" },
              { name: "Histórico" },
            ]}
          />
        </div>

        {/* Filtros */}
        <div className="paylote-table-card paylote-hist-filter-bar mb-4">
          <div className="paylote-hist-filter-row">
            {/* Busca */}
            <div className="paylote-form-field paylote-hist-field">
              <label className="paylote-label">Buscar</label>
              <div className="paylote-hist-search-wrap">
                <input
                  className="paylote-input paylote-hist-search-input"
                  placeholder="Lote, usuário, detalhe…"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* Filtro usuário */}
            <div className="paylote-form-field paylote-hist-field-sm">
              <label className="paylote-label">Usuário</label>
              <input
                className="paylote-input"
                placeholder="Nome do usuário"
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
              />
            </div>

            {/* Filtro ação */}
            <div className="paylote-form-field paylote-hist-field-sm">
              <label className="paylote-label">Tipo de ação</label>
              <select
                className="paylote-select"
                value={filterAction}
                onChange={(e) => setFilterAction(e.target.value)}
              >
                <option value="">Todas</option>
                <option value="CRIOU_LOTE">Criou lote</option>
                <option value="VALIDOU_CONTAS">Validou contas</option>
                <option value="LIBEROU_PAGAMENTO">Liberou pagamento</option>
                <option value="APROVOU_LOTE">Aprovou lote</option>
                <option value="REJEITOU_LOTE">Rejeitou lote</option>
                <option value="EXCLUIU_LOTE">Excluiu lote</option>
                <option value="ADICIONOU_CONTA">Adicionou conta</option>
                <option value="ENVIOU_PARA_APROVACAO">Enviou para aprovação</option>
              </select>
            </div>

            {(search || filterUser || filterAction) && (
              <button
                className="paylote-btn-secondary paylote-hist-clear-btn"
                onClick={() => { setSearch(""); setFilterUser(""); setFilterAction(""); }}
              >
                Limpar filtros
              </button>
            )}
          </div>
        </div>

        {/* Tabela */}
        <div className="paylote-table-card">
          <div className="paylote-hist-section-header">
            <TbHistory size={18} className="paylote-hist-section-icon" />
            <span className="paylote-hist-section-title">
              Registro de ações
            </span>
          </div>

          {(() => {
            if (loading) return (
              <div className="paylote-hist-empty">
                <p className="paylote-hist-empty-text">Carregando...</p>
              </div>
            );

            if (historico.length === 0) return (
              <div className="paylote-hist-empty">
                <TbHistory size={48} className="paylote-hist-empty-icon" />
                <p className="paylote-hist-empty-text">Nenhum registro encontrado.</p>
                <p className="paylote-hist-empty-sub">Tente ajustar os filtros acima.</p>
              </div>
            );

            return (
              <table className="paylote-table">
                <thead>
                  <tr>
                    <th>Data / Hora</th>
                    <th>Usuário</th>
                    <th>Ação</th>
                    <th>Detalhe</th>
                  </tr>
                </thead>
                <tbody>
                  {historico.map((r) => {
                    const aLabel = ACTION_LABELS[r.acao] || r.acao;
                    return (
                    <tr key={r.id}>
                      <td className="paylote-hist-date-cell">{formatDateTime(r.dataHora)}</td>
                      <td>
                        <div className="paylote-payee-name">{r.usuario}</div>
                      </td>
                      <td>
                        <span className={`paylote-hist-acao-badge paylote-hist-acao-${ACTION_COLOR_MAP[aLabel] || 'blue'}`}>
                          {ACTION_ICONS[aLabel]} {aLabel}
                        </span>
                      </td>
                      <td className="paylote-hist-detalhe-cell">{r.detalhe}</td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
